class PopupNews { 

    constructor(popup, options = {}){
        this.options = Object.assign(
            {},
            {    
                "waiting" : 200,
                "html" : "",
                "name_cookie" : "popup",
                "time_succes" : 2,
                "message" : {
                    "old_sub" : "Vous êtes déjà abonné(e).",
                    "new_sub" : "Merci pour votre inscrirption, vous recevrez dans quelques minutes votre sésame dans votre boite mail !",
                    "error" : "Une erreur est survenue, veuillez reesayer plus tard."
                } 
            }, 
            options 
        );    

        this.popup = popup; 



        if(this.getCookie(this.options.name_cookie) == null && !popupActive){
            popupActive = true;
            setTimeout(() => {
                this.popup.classList.remove("off"); 
            }, this.options.waiting) 
        } 

        if(this.popup.querySelector("#popup-subscribe") != null){
            this.popup.querySelector("#popup-subscribe").addEventListener("click", () => {
                this.popup.querySelector("#popup-subscribe").classList.add("loading");
                let email =  document.querySelector("#email-popup").value;
                this.subBrevo(email, "section-popup"); 
            }); 
        }

        if(this.popup.querySelector(".content-cta a") != null){
            this.popup.querySelector(".content-cta a").addEventListener("click", (event) => {
                event.preventDefault();
                this.removePopup(false);
                console.log(event);
                window.location.href = event.target.url;
            });
        }

        this.popup.querySelector(".close").addEventListener("click", () =>{ 
            popup.classList.add("off");  
            this.setCookie(this.options.name_cookie, true, 365); 
        }); 
        
    }

    async subBrevo(email, source){   
        const call = await fetch(`https://kmv0qf41j4.execute-api.eu-west-3.amazonaws.com/Prod/brevo/subscribe/${email}/${source}`);  
        const rep = await call.json();    
        this.popup.querySelector("#popup-subscribe").classList.remove("loading");
        this.popup.querySelector(".form .content-field").classList.add("hide");
        if(rep.success && !rep.data){
            this.popup.querySelector(".form .success").classList.add("ok"); 
            this.popup.querySelector(".form .success").innerHTML = this.options.message.new_sub;
            this.removePopup();
        }else if (!rep.success && rep.error == "already_exists"){
            this.popup.querySelector(".form .success").classList.add("ok");
            this.popup.querySelector(".form .success").innerHTML = this.options.message.old_sub;
            this.removePopup();
        }else{ 
            this.popup.querySelector(".form .success").classList.add("ok"); 
            this.popup.querySelector(".form .success").innerHTML = this.options.message.error;
        } 
 
    } 

    removePopup(waiting = true){   
        if(waiting){
            this.popup.querySelector(".content-progress .progress").style.transition = `all ${this.options.time_succes}s ease`;
            this.popup.querySelector(".content-progress .progress").style.width = "100%";
            let timeout = this.options.time_succes * 1000;
            setTimeout(()=>{
                this.popup.classList.add("off"); 
                this.setCookie(this.options.name_cookie, true, 365);  
            }, timeout);
        }else{
            this.popup.classList.add("off"); 
            this.setCookie(this.options.name_cookie, true, 365);  
        }
    }

    validationEmail(email){
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        }else{
            return false;
        }
    } 

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name,value,days) { 
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }  
 
}  